import { type ReactElement } from 'react';
import { Checkbox } from '@/Components/ui/checkbox';
import { Label } from '@/Components/ui/label';
import { InfoTooltip } from '@/Components/Feedback';
import { FieldError } from './FieldError';
import { cn } from '@/lib/utils';

interface CheckboxFieldProps {
    id?: string;
    name?: string;
    label: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    disabled?: boolean;
    description?: string;
    error?: string;
    className?: string;
}

export function CheckboxField({
    id,
    name,
    label,
    checked,
    onCheckedChange,
    disabled,
    description,
    error,
    className,
}: CheckboxFieldProps): ReactElement {
    const fieldId = id ?? name;

    return (
        <div className={cn('space-y-1.5', className)}>
            <div className="flex items-center gap-2">
                <Checkbox
                    id={fieldId}
                    name={name}
                    checked={checked}
                    onCheckedChange={(v) => onCheckedChange(v === true)}
                    disabled={disabled}
                    className={error ? "border-destructive focus-visible:ring-destructive" : ""}
                />
                <Label htmlFor={fieldId} className="flex items-center gap-1.5 cursor-pointer text-sm font-normal select-none">
                    {label}
                    {description && <InfoTooltip content={description} />}
                </Label>
            </div>
            {error && <FieldError message={error} />}
        </div>
    );
}
